import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.scss";
import Layout from "./shared/components/Layout";
import usePublicRoutes from "./public/hooks/usePublicRoutes";
import usePublicV2Routes from "./public/hooks/usePublicV2Routes";
import useAccountRoutes from "./account/hooks/useAccountRoutes";
import useAdminRoutes from "./admin/hooks/useAdminRoutes";
import useTechRoutes from "./tech/hooks/useTechRoutes";
import useCustomerRoutes from "./customer/useCustomerRoutes";
import { Box } from "@mui/material";

function App() {
  return (
    <Box display="flex" style={{ height: "100%" }}>
      <BrowserRouter>
        <Routes>
          <Route path="public">
            {usePublicRoutes()}
          </Route>

          <Route path="public-v2">
            {usePublicV2Routes()}
          </Route>

          <Route path="account">
            {useAccountRoutes()}
          </Route>

          <Route path="/" element={<Layout />}>
            <Route path="admin">{useAdminRoutes()}</Route>
            <Route path="tech">{useTechRoutes()}</Route>
            <Route path="">{useCustomerRoutes()}</Route>
            <Route path="*" element={<Navigate to="" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Box>
  );
}

export default App;
